<!-- Main Layout Container -->
<div class="h-dvh w-screen flex relative overflow-hidden">
  <!-- Sidebar -->
  <div
    class="sidebar fixed left-0 top-0 h-dvh z-30 bg-white border-r border-gray-300 transition-all duration-300 ease-in-out shadow-sm"
    [style.width]="issidebarCollapsed ? '75px' : '280px'"
    [class.hidden]="isMobile() && !isSidebarOpen()">
    <div class="p-2 h-full relative flex flex-col">
      <div class="flex flex-col gap-2 mt-4 w-full">
        <div class="nav-link w-full">
          <app-sidebar [isCollapsed]="issidebarCollapsed" (currentMenu)="heading($event)" (toggleSidebarParent)="onToggleSidebarFromChild()"
            (openChangePassword)="openChangePasswordDialog()" (closeSidebar)="closeSidebar()"
            (openSearch)="openSearchPopup()" />
        </div>
      </div>
    </div>
  </div>

  <!-- Overlay for mobile -->
  <div *ngIf="isSidebarOpen() && isMobile()"
    class="fixed inset-0 bg-black bg-opacity-50 z-20 transition-opacity duration-300 ease-in-out"
    (click)="closeSidebar()"></div>

  <!-- Main Content -->
  <div class="flex-1 h-dvh flex flex-col transition-all duration-300 ease-in-out" [ngClass]="{
      'ml-[280px]': !issidebarCollapsed && !isMobile(),
      'ml-[75px]': issidebarCollapsed && !isMobile(),
      'ml-0': isMobile()
    }">
    <div class="h-full w-full overflow-hidden flex flex-col">
      <div class="mt-4 sm:mt-6 mx-2 sm:mx-4 bg-white" *ngIf="common.heading()">
        <h1 class="text-lg sm:text-xl md:text-2xl font-bold text-left">{{ common.heading() }}</h1>
        <div class="mt-3 sm:mt-4 h-px w-full bg-gray-300"></div>
      </div>
      <div class="bg-gray-100 w-full flex-1 overflow-hidden">
        <router-outlet (activate)="onChildActivated($event)"></router-outlet>
      </div>
    </div>
  </div>
</div>